
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { postExchangeCode } from '@/api/exchange-code';
import LogUtils from 'panda-log';
import { toast } from '../../../utils/common';
import moment from 'moment';

@Component
export default class ExchangePop extends Vue {
  @Prop() visible!: Boolean;

  codeForm = {
    name: '',
    value: null,
    cnt: null,
    expire_at: null,
  };

  loading = false;

  rules = {
    name: [{ required: true, message: '请输入兑换码名称', trigger: 'blur' }],
    cnt: [{ type: 'number', required: true, message: '请输入兑换码数量', trigger: 'blur' }],
    value: [{ type: 'number', required: true, message: '请输入兑换码面额', trigger: 'blur' }],
    expire_at: [{ type: 'date', required: true, message: '请选择时间', trigger: 'change' }],
  };

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        console.log(this.codeForm);
        this.postNewCode();
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  }

  @Emit()
  close() {}

  async postNewCode() {
    try {
      this.loading = true;
      const query = {
        ...this.codeForm,
        expire_at: moment((this.codeForm as any).expire_at)
          .endOf('day')
          .unix(),
      };
      const res = await postExchangeCode(query);
      toast(`已生成兑换码`, 'success');
      this.$emit('close');
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
}
